import { transition, trigger, style, animate, query, stagger, keyframes } from '@angular/animations';

export const notificationAnimation =
  trigger('notificationAnimation', [
    transition('* => *', [
      query(':enter',
        style({ opacity: 0, transform: 'translateY(-100%) scale(0.5)', marginBottom: '-50px' }), { optional: true }),
      query(':enter',
        stagger('300ms', [
          animate('.5s ease-in',
            keyframes([
              style({ opacity: 0, transform: 'translate(-50%, -100%) scale(0)', offset: 0 }),
              style({ opacity: 1, marginBottom: '*', transform: 'translate(-50%, -30%) scale(1)', offset: 0.3 }),
              style({ marginBottom: '*', transform: 'translate(-50%, -10%) scale(1.05)', offset: 0.6 }),
              style({ opacity: 1, transform: 'translate(-50%, 0) scale(1)', offset: 1 })
            ])
          )
        ]), { optional: true }),
      query(':leave',
        stagger('300ms', [
          animate('500ms ease-out',
            keyframes([
              style({ opacity: 1, transform: 'translateX(-50%) scale(1.02)', height: '*', margin: '*', offset: 0 }),
              style({ opacity: .8, transform: 'translateX(-50%) scale(1)', offset: 0.3 }),
              style({ opacity: .2, transform: 'translateX(-50%) scale(1)', offset: 0.7 }),
              style({ opacity: .1, transform: 'translateX(-50%) scale(.5)', offset: 0.9 }),
              style({ opacity: 0, transform: 'translateX(-50%) scale(0)', height: 0, margin: 0, offset: 1 })
            ])
          )
        ]), { optional: true })
    ])
  ]);
